export interface IFaqs {}

export default class Faqs implements IFaqs {
  constructor(obj: IFaqs) {
    Object.assign(this, obj);
  }

  static data = [
    {
      _id: 0,
      question:
        "Per fare marketing, perché l’esercente dovrebbe usare Adhesion invece che le sponsorizzate di Facebook, Instagram o Google Ads?",
      answer:
        "Adhesion è rivolto all’esercente che vuole aumentare le vendite con i clienti già acquisiti. L’esercente in questo modo concentra i propri sforzi verso clienti che già lo conoscono.\nFacebook, Instagram e Google sono strumenti molto più costosi e complessi che servono all’esercente per farsi conoscere da clienti a lui sconosciuti.",
    },
    {
      _id: 1,
      question: "Come può l’esercente aumentare la propria base utenti?",
      answer:
        "L’esercente può chiedere attraverso una promozione di Adhesion ai propri già clienti di portare degli amici, premiando entrambi attraverso uno sconto o un regalo.",
    },
    {
      _id: 2,
      question:
        "Sul listino di Adhesion si parla di piani proposti mensili, che vincoli di durata contrattuale ha l’esercente?",
      answer:
        "L’esercente una volta comprato lo Starter Kit, e finito il periodo di prova, può scegliere liberamente se continuare a utilizzare il prodotto oppure terminare il suo utilizzo ed il relativo pagamento.\nNessun importo viene richiesto all’esercente se questi decide di non utilizzare più il servizio.\nLa durata contrattuale minima è di un mese, che viene pagata anticipatamente. Se entro l’inizio del mese successivo non viene saldata la successiva mensilità, il servizio cessa e nulla è più dovuto da entrambe le parti.",
    },
    {
      _id: 3,
      question:
        "Per quale motivo i clienti dovrebbero scaricare Adhesion e associarsi all’esercente?",
      answer:
        "Questo processo avviene attraverso la Promo Benvenuto. Meglio questa promozione è concepita tanto più i clienti sono invogliati ad associarsi all’esercente.\nIl Manuale di Marketing contiene preziosi consigli su come sviluppare questa promozione.",
    },
    {
      _id: 4,
      question:
        "Adhesion può essere utilizzata attraverso un computer desktop?",
      answer:
        "No, Adhesion si installa solo su dispositivi mobili. Solo a questi ultimi è possibile mandare le notifiche push a cui i clienti possono rispondere in maniera immediata.",
    },
    {
      _id: 5,
      question:
        "Come faccio a sapere l’incremento di fatturato che ho realizzato grazie ad Adhesion?",
      answer:
        "Una volta raggiunta la base utenti minima associata all’esercente, quest’ultimo può confrontare le vendite che realizzava prima e dopo l’utilizzo della App.",
    },
    {
      _id: 6,
      question:
        "Sono proposti diversi piani mensili, quale è consigliato per iniziare?",
      answer:
        "I piani mensili si differenziano principalmente dal numero dei clienti che si possono associare; consigliamo il piano intermedio Premium, in qualunque momento è possibile cambiare tariffa.",
    },
    {
      _id: 7,
      question: "Chi decide come fare le promozioni?",
      answer:
        "La Promo Benvenuto e le successive promozioni vengono sviluppate in autonomia dall’esercente.\nIl team di Adhesion ha messo a disposizione un manuale di marketing che contiene i principi e alcuni esempi su come fare promozioni di successo.",
    },
    {
      _id: 8,
      question:
        "Dopo quanto tempo l’esercente può iniziare a valutare i risultati di Adhesion sulla propria attività?",
      answer:
        "Già dopo un mese di utilizzo, e quindi al termine del periodo compreso nello starter kit, l’esercente potrà valutare i risultati del servizio. In media dopo tale periodo l’esercente riesce a raddoppiare le vendite nei giorni di promozione rispetto allo stesso periodo prima dell'utilizzo del servizio.",
    },
    {
      _id: 9,
      question:
        "Ho scaricato l’applicazione e sembra non succeda niente. Come mai?",
      answer:
        "Una volta scaricata Adhesion occorre inquadrare il codice QR dell’esercente per associarsi ad esso. Una volta che il cliente si è associato egli può beneficiare della Promo Benvenuto e delle promozioni successive.",
    },
    {
      _id: 10,
      question:
        "Come fa il cliente a farsi riconoscere la promozione dall’esercente?",
      answer:
        "Il cliente si deve recare presso l’esercente durante la validità dell’offerta e mostrare lo schermo del proprio smartphone per provare che ha diritto alla promozione.",
    },
    {
      _id: 11,
      question:
        "I clienti di un esercente possono vedere le promozioni di un altro esercente a cui non si sono associati?",
      answer:
        "No, i clienti che si associano ad un esercente possono vedere solo le promozioni di quella attività.",
    },
    {
      _id: 12,
      question:
        "Un esercente può mandare delle promozioni a clienti di un’altra attività?",
      answer:
        "No, è impossibile. I clienti associati ad un esercente possono solo ricevere le promozioni solo da quella attività.",
    },
    {
      _id: 13,
      question:
        "Mandare troppe notifiche ai clienti può essere controproducente per l’esercente?",
      answer:
        "In linea di massima SI, ma Adhesion manda un numero limitato di notifiche push che devono essere collegate a promozioni interessanti per i clienti associati.\nE’ a disposizione il manuale di marketing affinchè l’esercente possa sviluppare offerte efficaci ed interessanti per i clienti.",
    },
    {
      _id: 14,
      question:
        "Posso mandare delle notifiche ai miei clienti, filtrandoli per sesso, preferenze, etc?",
      answer:
        "Allo stato attuale Adhesion App manda a tutti i clienti la stessa promozione. In seguito sarà possibile profilare la clientela e mandare offerte in maniera personalizzata.",
    },
  ];
}
